import moment, { Moment } from 'moment';

/**
 * MUI X's date field takes whatever digits land in the year slot, so typing
 * `26` yields year 0026 — a date that parses perfectly and saves silently.
 * That is the bad data SUP-426 reported, and swapping the native control for a
 * picker does NOT close it: clicking a segment and typing still writes it.
 *
 * Every date input bounds itself with these so a short or runaway year cannot
 * reach the form. Kept in one place so the pickers and the inline row editor
 * can't drift apart.
 */
export const MIN_PLAUSIBLE_YEAR = 1900;

export const MAX_PLAUSIBLE_YEARS_AHEAD = 100;

/** Earliest date any picker in the app will accept. */
export function plausibleMinDate(): Moment {
  return moment(`${MIN_PLAUSIBLE_YEAR}-01-01`);
}

/** Latest date any picker in the app will accept. */
export function plausibleMaxDate(): Moment {
  return moment().add(MAX_PLAUSIBLE_YEARS_AHEAD, 'years');
}

/**
 * True when a date's year is plausible. `moment.isValid()` is not enough —
 * year 0026 is a valid date.
 * @param value
 */
export function isPlausibleDate(value: Moment | null | undefined): boolean {
  if (!value || !value.isValid()) return false;
  const year = value.year();
  return (
    year >= MIN_PLAUSIBLE_YEAR &&
    year <= moment().year() + MAX_PLAUSIBLE_YEARS_AHEAD
  );
}
